<template>
  <div class="flex-center search-item" :class="{fill: type}">
    <span v-if="label" class="item-label" :style="{minWidth: minWidthPx}">{{ label }}</span>
    <slot v-if='!contentWidth'></slot>
    <div :style="{width: contentWidth + 'px'}" v-else>
      <slot></slot>
    </div>
  </div>
</template>
<script>
export default {
  name: 'SearchItem',
  props: {
    label: {
      type: String,
      default: ''
    },
    minWidth: {
      type: Number,
      default: 0
    },
    contentWidth: {
      type: Number,
      default: 0
    },
    type: {
      type: String,
      default: ''
    }
  },
  computed:{
    minWidthPx() {
      return this.minWidth && `${this.minWidth}px` || ''
    }
  }
}
</script>
<style lang="scss" scoped>
  .item-label {
    font-size: 14px;
    color: #666;
    margin-right: 12px;
    margin-left: 24px;
    text-align: right;
    white-space: nowrap;
  }
  .search-item {
    &:nth-of-type(1) {
      .item-label {
        margin-left: 0;
      }
    }
    &.first {
      .item-label {
        margin-left: 0;
      }
    }
    &.fill {
      /deep/ .el-input__inner, /deep/ .el-select {
        width: 100%;
      }
    }
  }
  /deep/ .el-date-editor {
    width: 100%;
  }
  /deep/ .time-picker-input {
    width: 142px;
    .el-input__inner {
      padding-right: 26px
    }
  }
</style>